// extracted by mini-css-extract-plugin
export default {"container":"ManagerList_container__CuVbC"};